

























































































































































import { Component, Vue } from 'vue-property-decorator';
import { PriceListService } from '../services/PriceListService';
import { Region } from '../models/Region';
import { ListType } from '../models/ListType';
import { PriceListModel } from '../models/PriceList';
import { Assortment } from '../models/Assortment';
import { TreeSpecie } from '../models/TreeSpecie';
import { Consoler } from '@/utils/Consoler';

@Component
export default class PriceList extends Vue {
  private regions: Array<Region> = [];
  private selectedRegion = '';
  private listTypes: Array<ListType> = [];
  private selectedListTypes: Array<string> = [];
  private treeSpecies: Array<TreeSpecie> = [];
  private selectedTreeSpecies: Array<string> = [];
  private assortments: Array<Assortment> = [];
  private selectedAssortments: Array<string> = [];
  private priceList: Array<PriceListModel> = [];
  private filteredPriceList: Array<PriceListModel> = [];
  private isLoading = true;
  private hasError = false;

  mounted(): void {
    this.getPriceList();
    this.initializePreCheckedBoxes();
  }

  getPriceList(): Promise<any> {
    return PriceListService.getPriceList()
      .then(response => {
        this.regions = response.data.lookupData.regions;
        this.listTypes = response.data.lookupData.listTypes;
        this.treeSpecies = response.data.lookupData.treeSpecies;
        this.assortments = response.data.lookupData.assortments;
        this.priceList = response.data.pricelists;
      })
      .catch(error => {
        Consoler.debugLog(error);
        this.hasError = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private initializePreCheckedBoxes() {
    const preCheckedListType: Array<string> = ['Leveransvirke'];
    const preCheckedTreeSpecies: Array<string> = ['Gran', 'Tall', 'Löv'];
    const preCheckedAssortments: Array<string> = [
      'Normaltimmer',
      'Klentimmer',
      'Massaved',
      'Kubb',
      'Bränsleved',
      'Specialsortiment'
    ];

    this.selectedListTypes = preCheckedListType;
    this.selectedTreeSpecies = preCheckedTreeSpecies;
    this.selectedAssortments = preCheckedAssortments;
  }

  private downloadPrice(id: string, name: string) {
    return PriceListService.downloadPriceFile(id, name).catch(error => {
      Consoler.debugLog(error);
      this.hasError = true;
    });
  }

  private onFilterPropertyChange() {
    if (this.selectedRegion === '') {
      return (this.filteredPriceList = []);
    }

    const newPriceList = [];
    var temporaryPriceList = [];

    temporaryPriceList = this.priceList.filter(p =>
      p.regions.includes(this.selectedRegion)
    );
    if (temporaryPriceList.length === 0) {
      temporaryPriceList = this.priceList.filter(p =>
        p.vos.includes(this.selectedRegion)
      );
    }

    temporaryPriceList.forEach(product => {
      let treeSpeciesHit = false;
      let listTypeHit = false;
      let assortmentHit = false;

      product.treeSpecies.forEach(treeSpecie => {
        if (this.selectedTreeSpecies.length <= 0) {
          treeSpeciesHit = true;
          return;
        }

        if (
          this.selectedTreeSpecies.some(
            t => t.toLowerCase() === treeSpecie.toLowerCase()
          )
        ) {
          treeSpeciesHit = true;
        }
      });

      product.listTypes.forEach(type => {
        if (this.selectedListTypes.length <= 0) {
          listTypeHit = true;
          return;
        }

        if (
          this.selectedListTypes.some(
            t => t.toLowerCase() === type.toLowerCase()
          )
        ) {
          listTypeHit = true;
        }
      });

      if (this.selectedAssortments.length <= 0) {
        assortmentHit = true;
      } else if (
        this.selectedAssortments.some(
          a => a.toLowerCase() === product.assortment.toLowerCase()
        )
      ) {
        assortmentHit = true;
      }

      if (treeSpeciesHit && listTypeHit && assortmentHit) {
        newPriceList.push(product);
      }
    });

    return (this.filteredPriceList = newPriceList);
  }

  private closeError() {
    this.hasError = false;
  }
}
